/**
 * Short scheduling links resolved server-side by sketchy (`/{uid}/<path>`).
 *
 * PRIORITY_LINK_PATH must match sketchy's `PRIORITY_LINK_PATH`
 * (sketchy/links.py, KAN-2655). It is patient-facing, so it must not say
 * "priority". sketchy always books the Acuity "Priority Patients" type
 * (PRIORITY_COACHING_CALL) from this link, whatever the patient's status.
 */
export const THIRTY_MINUTE_LINK_PATH = "thirty-minutes";
export const PRIORITY_LINK_PATH = "starlight_call";

export const thirtyMinuteSchedulingLink = (schedulingLink: string) =>
	`${schedulingLink}/${THIRTY_MINUTE_LINK_PATH}`;

export const prioritySchedulingLink = (schedulingLink: string) =>
	`${schedulingLink}/${PRIORITY_LINK_PATH}`;
